var _excluded = ["children"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import { StyledBadge } from './Badge.styled';
function Badge(_ref) {
  var children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledBadge, rest, children);
}
Badge.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The anchor of the badge.
   */
  anchorOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOf(['left', 'right']),
    vertical: PropTypes.oneOf(['bottom', 'top'])
  }),
  /**
   * The content rendered within the badge.
   */
  badgeContent: PropTypes.node,
  /**
   * The badge will be added relative to this node.
   */
  children: PropTypes.node.isRequired,
  /**
   * The color of the component. It supports those theme colors
   * that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'error', 'primary', 'secondary']),
  /**
   * If `true`, the badge will be invisible.
   */
  invisible: PropTypes.bool,
  /**
   * Max count to show.
   */
  max: PropTypes.number,
  /**
   * The shape of the Badge.
   */
  overlap: PropTypes.oneOf(['circular', 'rectangular']),
  /**
   * Controls whether the badge is hidden when badgeContent is zero.
   */
  showZero: PropTypes.bool,
  /**
   * The shape of the Badge.
   */
  variant: PropTypes.oneOf(['dot', 'standard'])
} : {};
Badge.defaultProps = {
  anchorOrigin: {
    horizontal: 'right',
    vertical: 'top'
  },
  badgeContent: ' ',
  color: 'error',
  invisible: false,
  max: 99,
  overlap: 'circular',
  showZero: false,
  variant: 'standard'
};
export default Badge;